(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-parameter', {
            parent: 'entity',
            url: '/lead-parameter?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadParameter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-parameter/lead-parameters.html',
                    controller: 'LeadParameterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadParameter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-parameter-detail', {
            parent: 'entity',
            url: '/lead-parameter/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadParameter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-detail.html',
                    controller: 'LeadParameterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadParameter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadParameter', function($stateParams, LeadParameter) {
                    return LeadParameter.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-parameter.new', {
            parent: 'lead-parameter',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-dialog.html',
                    controller: 'LeadParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-parameter', null, { reload: true });
                }, function() {
                    $state.go('lead-parameter');
                });
            }]
        })
        .state('lead-parameter.edit', {
            parent: 'lead-parameter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-dialog.html',
                    controller: 'LeadParameterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadParameter', function(LeadParameter) {
                            return LeadParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-parameter.delete', {
            parent: 'lead-parameter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-parameter/lead-parameter-delete-dialog.html',
                    controller: 'LeadParameterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadParameter', function(LeadParameter) {
                            return LeadParameter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-parameter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
